import { render, staticRenderFns } from "./DeselectedReadonly.vue?vue&type=template&id=e5c64b32"
import script from "./DeselectedReadonly.vue?vue&type=script&lang=js"
export * from "./DeselectedReadonly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports